module.exports = __webpack_public_path__ + "media/img/favicon-16x16-adab91339390dd980c535513b776eab3.png";